var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.516 6.40817L9.45853 3.41073C9.41227 2.76086 9.57065 2.11273 9.91237 1.55351C10.2541 0.994286 10.7628 0.550788 11.37 0.282666C11.9772 0.0145445 12.6538 -0.065342 13.3088 0.0537512C13.9638 0.172844 14.5659 0.485205 15.0339 0.948823C15.5065 1.40762 15.8246 1.99658 15.9456 2.63693C16.0666 3.27728 15.9847 3.93849 15.7109 4.5321C15.4371 5.12572 14.9845 5.62345 14.4135 5.95871C13.8426 6.29397 13.1806 6.45078 12.516 6.40817ZM1.15268 12.2432L8.67372 4.89746L10.9873 7.15953L3.46622 14.5133L1.16086 12.2432H1.15268ZM0.00817504 14.5053L1.73311 12.8107L2.89397 13.9458L1.16086 15.6403L0 14.5053H0.00817504ZM7.81534 12.0034L9.45035 10.4048V16H7.81534V12.0034Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArt);
export default __webpack_public_path__ + "static/media/art.9a0631bfea04290bafddcf1d207a6980.svg";
export { ForwardRef as ReactComponent };